"use strict";
import * as fabric from "fabric";
window.APP = window.APP || {};
APP.LabelPreviewView = Backbone.View.extend({
  template: _.template($("#screen5Template").html()),
  initialize: function (options) {
    this.brandid = window.data.get("brand");
    this.gender = window.data.get("gender");
    this.name = window.data.get("name");
    if (this.brandid == "") {
      this.brandid = 1;
      window.data.set("brand", 1);
      window.data.set("name", "Pip");
      window.data.set("gender", "male");
    }
  },
  // populate the html to the dom
  render: function () {
    this.$el.html(this.template({ brandid: this.brandid }));
    // Initialize fabric canvas after DOM is ready
    setTimeout(async () => {
      // Forzar la carga de la fuente antes de usarla
      await document.fonts.load("bold 120px Mermaid");

      // Verificar que la fuente esté disponible
      const fontAvailable = document.fonts.check("bold 120px Mermaid");
      console.log("Mermaid font available:", fontAvailable);

      // set canvas size
      const canvas = new fabric.Canvas("canvas", {
        selection: false,
        allowTouchScrolling: true,
      });

      // Deshabilitar interacción con todos los objetos
      canvas.forEachObject(function (obj) {
        obj.selectable = false;
        obj.evented = false;
      });

      // add image to fabric canvas with error handling
      const imgPath = "images/offline/brand_" + this.brandid + "_cru.png";
      console.log("Attempting to load image from:", imgPath);
      // Create image element to test loading
      const testImg = new Image();
      testImg.onload = function () {
        console.log("Image loaded via Image element", testImg.width, testImg.height);
        // Use FabricImage instead of Image in Fabric v6
        fabric.FabricImage.fromURL(imgPath)
          .then((img) => {
            console.log("Fabric image loaded successfully", img.width, img.height);
            // Calculate scale to fit canvas while maintaining aspect ratio
            const scaleX = canvas.width / img.width;
            const scaleY = canvas.height / img.height;
            const scale = Math.min(scaleX, scaleY); // Use minimum to fit inside canvas
            img.set({
              left: 0,
              top: 0,
              scaleX: scale,
              scaleY: scale, // Use same scale for both axes to maintain aspect ratio
              selectable: false,
              evented: false,
            });
            canvas.add(img);

            // add text to canvas

            let name = window.data.get("name").trim().substring(0, 6);

            // Agregar caja de fondo para visualizar el área del texto
            let textCenterX = 490; // Posición X del centro del texto
            const textBox = new fabric.Rect({
              left: textCenterX,
              top: 282,
              width: 300,
              height: 150,
              fill: "rgba(255, 0, 0, 0.2)",
              stroke: "red",
              strokeWidth: 2,
              originX: "center",
              originY: "center",
              selectable: false,
              evented: false,
            });
            //canvas.add(textBox);

            const text = new fabric.FabricText(name, {
              left: textCenterX,
              top: 282,
              fontFamily: "Mermaid",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 120,
              fill: "black",
              originX: "center",
              originY: "center",
              charSpacing: -50,
              selectable: false,
              evented: false,
            });

            // Obtener el ancho final del texto
            console.log("Text width:", text.width);
            console.log("Text bounding rect:", text.getBoundingRect());

            // Calcular posición de la imagen de género alineada con el texto centrado
            const textBounds = text.getBoundingRect();
            const gender = window.data.get("gender");
            const genderImgWidth = gender === "female" ? 279 : 228;
            const genderImgLeft = textBounds.left - genderImgWidth * scale - 10; // 10px de separación

            canvas.add(text);

            // load gender label
            const genderImgPath = "images/offline/" + gender + ".png";
            fabric.FabricImage.fromURL(genderImgPath).then((genderImg) => {
              console.log("Gender image loaded successfully", genderImg.width, genderImg.height);

              genderImg.set({
                left: genderImgLeft,
                top: 225,
                scaleX: scale,
                scaleY: scale,
                selectable: false,
                evented: false,
              });
              canvas.add(genderImg);
              canvas.renderAll();
              const dataURL = canvas.toDataURL({
                format: "png",
                quality: 1.0,
              });
              window.previewImage = dataURL;
            });
            canvas.renderAll();
            // get image data URL
            const dataURL = canvas.toDataURL({
              format: "png",
              quality: 1.0,
            });
            window.previewImage = dataURL;
            // You can use dataURL here, e.g., set it as an image source or send it to a server
          })
          .catch((err) => {
            console.error("Failed to load image in fabric:", err);
          });
      };
      testImg.onerror = function () {
        console.error("Failed to load image via Image element from:", imgPath);
      };
      testImg.src = imgPath;
    }, 100);
    return this;
  },
});
